import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { routes } from '../../../constants/routes'


const mapStateToProps = (state) => {
    return {
        agents: state.agents
    }
}

const ListAgents = ({ agents }) => {
    return (
        <div>
            <h1>Agents</h1>
            <Link to={routes.agentsCreate}>+ Create Agent</Link>
        </div>
    )
}

export default connect(mapStateToProps)(ListAgents)
